export class AccountApiNetworkError extends Error {
  readonly proxyBase: string;

  constructor(
    message: string,
    proxyBase: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'AccountApiNetworkError';
    this.proxyBase = proxyBase;
  }
}
